// extracted by mini-css-extract-plugin
module.exports = {"icon":"StatisticsIcon_icon__1lgeM"};